import React, {FunctionComponent} from "react";
import {PageTemplate} from "../../common/page-template/PageTemplate";
import {useTranslation} from "react-i18next";
import {Box, Link} from "@mui/material";
import {styled} from "@mui/material/styles";

const AppLink=styled(Link)(({theme})=>({
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    color: theme.palette.secondary.main
}));

const CustomLicenseBox = styled(Box)(() => ({
    display: 'inline-block',
    padding: '10px',
    border: '1px solid rgba(0,0,0,0.85)',
    margin: '10px 0'
}));

export const Credits: FunctionComponent = () => {
    const {t} = useTranslation();

    return <PageTemplate
        pageTitle={t("Credits")}>

        <ul>
            <li>
                @mui (MIT): <AppLink
                href="https://mui.com/"
                target="_blank">https://material-ui.com/</AppLink>
            </li>
            <li>
                @types/node (MIT): <AppLink
                href="https://github.com/DefinitelyTyped/DefinitelyTyped"
                target="_blank">https://github.com/DefinitelyTyped/DefinitelyTyped</AppLink>
            </li>
            <li>
                @types/react (MIT): <AppLink
                href="https://github.com/DefinitelyTyped/DefinitelyTyped"
                target="_blank">https://github.com/DefinitelyTyped/DefinitelyTyped</AppLink>
            </li>
            <li>
                @types/react-dom (MIT): <AppLink
                href="https://github.com/DefinitelyTyped/DefinitelyTyped"
                target="_blank">https://github.com/DefinitelyTyped/DefinitelyTyped</AppLink>
            </li>
            <li>
                jest (MIT): <AppLink href="https://jestjs.io/"
                                     target="_blank">https://jestjs.io/</AppLink>
            </li>
            <li>
                react (MIT): <AppLink href="https://reactjs.org/"
                                      target="_blank">https://reactjs.org/</AppLink>
            </li>
            <li>
                react-dom (MIT): <AppLink
                href="https://reactjs.org/"
                target="_blank">https://reactjs.org/</AppLink>
            </li>
            <li>
                react-redux (MIT): <AppLink
                href="https://github.com/reduxjs/react-redux"
                target="_blank">https://github.com/reduxjs/react-redux</AppLink>
            </li>
            <li>
                reduxjs/toolkit (MIT): <AppLink
                href="https://redux-toolkit.js.org/"
                target="_blank">https://redux-toolkit.js.org/</AppLink>
            </li>
            <li>
                typescript (Apache-2.0): <AppLink
                href="https://www.typescriptlang.org/"
                target="_blank">https://www.typescriptlang.org/</AppLink>
            </li>


            <li>
                jose-jwt (MIT): <AppLink
                href="https://github.com/dvsekhvalnov/jose-jwt"
                target="_blank">https://github.com/dvsekhvalnov/jose-jwt</AppLink>
            </li>
            <li>
                Bouncy Castle (MIT): <AppLink
                href="https://www.bouncycastle.org/csharp/"
                target="_blank">https://www.bouncycastle.org/csharp/</AppLink>
            </li>
            <li>
                NUnit (*): <AppLink
                href="https://nunit.org/"
                target="_blank">https://nunit.org/</AppLink>
                <div>
                    <CustomLicenseBox>
                        Copyright (c) 2022 Charlie Poole, Rob Prouse<br/>
                        <br/>
                        Permission is hereby granted, free of charge, to any person obtaining a copy<br/>
                        of this software and associated documentation files (the "Software"), to deal<br/>
                        in the Software without restriction, including without limitation the rights<br/>
                        to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br/>
                        copies of the Software, and to permit persons to whom the Software is<br/>
                        furnished to do so, subject to the following conditions:<br/>
                        <br/>
                        The above copyright notice and this permission notice shall be included in<br/>
                        all copies or substantial portions of the Software.<br/>
                        <br/>
                        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br/>
                        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br/>
                        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br/>
                        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br/>
                        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br/>
                        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br/>
                        THE SOFTWARE.<br/>
                    </CustomLicenseBox>
                </div>
            </li>
            <li>Swashbuckle.AspNetCore (MIT): <AppLink
                href="https://github.com/domaindrivendev/Swashbuckle.AspNetCore"
                target="_blank">https://github.com/domaindrivendev/Swashbuckle.AspNetCore</AppLink>
            </li>
            <li>Evolve (MIT): <AppLink
                href="https://evolve-db.netlify.app/"
                target="_blank">https://evolve-db.netlify.app/</AppLink>
            </li>
            <li>CsvHelper (MS-PL OR Apache-2.0): <AppLink
                href="https://joshclose.github.io/CsvHelper/"
                target="_blank">https://joshclose.github.io/CsvHelper/</AppLink>
            </li>
            <li>Moq (BSD 3): <AppLink
                href="https://github.com/moq/moq4"
                target="_blank">https://github.com/moq/moq4</AppLink>
            </li>
            <li>Serilog (Apache-2.0): <AppLink
                href="https://serilog.net/"
                target="_blank">https://serilog.net/</AppLink>
            </li>
            <li>coverlet.collector (MIT): <AppLink
                href="https://github.com/coverlet-coverage/coverlet"
                target="_blank">https://github.com/coverlet-coverage/coverlet</AppLink>
            </li>
        </ul>
    </PageTemplate>
}